import { render, staticRenderFns } from "./ReviewsQRCode.vue?vue&type=template&id=216a7fc2&"
import script from "./ReviewsQRCode.vue?vue&type=script&lang=js&"
export * from "./ReviewsQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports